export const ALERT_TYPE_ERROR = 'ERROR'
export const ALERT_TYPE_WARNING = 'WARNING'
export const ALERT_TYPE_INFO = 'INFO'
export const ALERT_ORIGIN_FRONTEND = 'ALERT_ORIGIN_FRONTEND'
export const ALERT_ORIGIN_BACKEND = 'ALERT_ORIGIN_BACKEND'
